import numeral from 'numeral';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const hasMoreData = (data, size, totalResults?) => {
  if (totalResults) {
    const pageSize = data.pages.length;
    const lastPageSize = data.pages[data.pages.length - 1].results.length;
    return totalResults > pageSize * size + lastPageSize;
  }
  return data && data.pages[0]?.length === size && data.pages[data.pages.length - 1].length > 0;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatResultsText = (data) => {
  const totalResults = data?.pages[0]?.totalResults;
  if (!totalResults) {
    return 'No Results Found';
  }
  if (totalResults === 1) {
    return '1 result';
  }
  return `${numeral(totalResults).format('0,0')} results`;
};
